import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { MenuService } from 'src/app/layout/app.menu.service';

@Component({
  selector: 'app-not-found',
  templateUrl: './not-found.component.html',
  styleUrls: ['./not-found.component.scss']
})
export class NotFoundComponent {

  homeRoute: any;

  constructor(
    private router: Router,
    private menuService: MenuService
  ) {
    this.homeRoute = this.menuService.homeRoute;
  }

  goHome() {
    this.router.navigate([this.homeRoute]);
  }
}
